var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2617 0.841431L11.072 2.03114M11.072 2.03114L12.8566 3.8157L10.7746 5.8977L8.99004 4.11313M11.072 2.03114L8.99004 4.11313M6.54518 6.55798C6.85233 6.86104 7.0965 7.22187 7.26362 7.61968C7.43075 8.01749 7.51753 8.44443 7.51898 8.87591C7.52042 9.3074 7.4365 9.73491 7.27205 10.1338C7.10759 10.5328 6.86585 10.8952 6.56074 11.2003C6.25563 11.5054 5.89318 11.7472 5.49426 11.9116C5.09534 12.0761 4.66782 12.16 4.23633 12.1586C3.80485 12.1571 3.37791 12.0703 2.9801 11.9032C2.58229 11.7361 2.22146 11.4919 1.91841 11.1848C1.32244 10.5677 0.992669 9.74128 1.00012 8.88345C1.00758 8.02562 1.35166 7.20503 1.95826 6.59843C2.56486 5.99183 3.38544 5.64775 4.24327 5.6403C5.1011 5.63284 5.92754 5.96261 6.54459 6.55858L6.54518 6.55798ZM6.54518 6.55798L8.99004 4.11313",
    stroke: "#17A1FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.76c0b2d947bc996958bbe03c794acfd7.svg";
export { ForwardRef as ReactComponent };